import produce from "immer";
import React, { FC } from "react";
import { Accordion, Button, Card } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { uuid } from "uuidv4";
import { startRemoveByDustbin } from "../../../../actions/dustbinAction";
import {
  startAddTab,
  startEditTab,
  startRemoveTab,
} from "../../../../actions/tabListAction";
import { Element } from "../../../../models/elementModel";
import { Row } from "../../../../models/rowModel";
import { Section } from "../../../../models/sectionModel";
import { TabModel } from "../../../../models/tabModel";
import { AppState } from "../../../../reducers/rootReducer";
import { getAllRows } from "../../../../selectors/rowListSelector";
import { getSubTabListByTab } from "../../../../selectors/tabListSelector";
import "../elementProprtiesPanal.scss";
import Switch from "react-switch";


export interface TabItemPropertiesProps {
  tab: TabModel;
}

const TabItemProperties: FC<TabItemPropertiesProps> = ({ tab }) => {
  const dispatch = useDispatch();
  const subTabList = useSelector(getSubTabListByTab(tab));
  const sessionState = useSelector((state: AppState) => state.session);
  const rowState = useSelector(getAllRows);
  const sectionState = useSelector((state: AppState) => state.sectionList);
  const elementState = useSelector((state: AppState) => state.elementList);
  const tabState = useSelector((state: AppState) => state.tabList);

  const tabCardDisplayName = tab.isDropDownTab ? tab.tabGroupTitle : tab.name;

  const editTabName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTab = produce(tab, (draft) => {
      draft.name = e.target.value;
    });
    dispatch(startEditTab(newTab));
  };

  const editTabGroupName = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newTab = produce(tab, (draft) => {
      draft.tabGroupTitle = e.target.value;
    });
    dispatch(startEditTab(newTab));
  };

  const editSubTabName = (
    e: React.ChangeEvent<HTMLInputElement>,
    subTab: TabModel
  ) => {
    const newSubTab = produce(subTab, (draft) => {
      draft.name = e.target.value;
    });
    dispatch(startEditTab(newSubTab));
  };

  const addNewTabOption = () => {
    dispatch(
      startAddTab({
        elementId: tab.elementId,
        formId: tab.formId,
        name: "Tab",
        properties: {},
        styles: {},
        isDropDownTab: true,
        isMain: false,
        pairedKey: tab.pairedKey,
        tabGroupTitle: tab.tabGroupTitle,
      })
    );
  };

  const findTabDependents = (tabs: TabModel[]) => {
    let rowList: Row[] = [];
    let sectionList: Section[] = [];
    let elementList: Element[] = [];

    for (let i = 0; i < tabs.length; i++) {
      const tempRowListByTabId: Row[] = rowState.filter((row) => {
        return row.tabId === tabs[i].id;
      });
      rowList = rowList.concat(tempRowListByTabId);
    }

    for (let j = 0; j < rowList.length; j++) {
      const tempSectionListByRowId: Section[] = sectionState.filter(
        (section) => {
          return section.rowId === rowList[j].id;
        }
      );
      sectionList = sectionList.concat(tempSectionListByRowId);
    }

    for (let k = 0; k < sectionList.length; k++) {
      const tempElementListToRemoveBySectionId: Element[] = elementState.present.filter(
        (element) => {
          return element.sectionId === sectionList[k].id;
        }
      );
      elementList = elementList.concat(tempElementListToRemoveBySectionId);
    }

    return {
      rowList: rowList,
      sectionList: sectionList,
      elementList: elementList,
    };
  };

  const findTabListByTab = (elementId: String, tabId: String) => {
    let tabList: TabModel[] = tabState.filter((tab) => {
      if (tabId === "") {
        if (tab.elementId === elementId) return tab;
      } else {
        if (tab.elementId === elementId && tab.id === tabId) return tab;
      }
    });

    let rowListByTabElement: Row[] = [];
    let sectionListByTabElement: Section[] = [];
    let elementListByTabElement: Element[] = [];

    for (let i = 0; i < tabList.length; i++) {
      const tempRowListByTabId: Row[] = rowState.filter((row) => {
        if (row.type === "Tab" && row.tabId === tabList[i].id) return row;
      });
      rowListByTabElement = rowListByTabElement.concat(tempRowListByTabId);
    }

    for (let j = 0; j < rowListByTabElement.length; j++) {
      const tempSectionListByRowId: Section[] = sectionState.filter(
        (section) => {
          return section.rowId === rowListByTabElement[j].id;
        }
      );
      sectionListByTabElement = sectionListByTabElement.concat(
        tempSectionListByRowId
      );
    }

    for (let k = 0; k < sectionListByTabElement.length; k++) {
      const tempElementListToRemoveBySectionId: Element[] = elementState.present.filter(
        (element) => {
          return element.sectionId === sectionListByTabElement[k].id;
        }
      );
      elementListByTabElement = elementListByTabElement.concat(
        tempElementListToRemoveBySectionId
      );
    }

    for (let index = 0; index < elementListByTabElement.length; index++) {
      if (elementListByTabElement[index].type === "tab") {
        tabList = tabList.concat(
          findTabListByTab(elementListByTabElement[index].id, "")
        );
      }
    }

    return tabList;
  };

  const removeTab = (item: TabModel) => {
    let tabListToRemove: TabModel[] = findTabListByTab(item.elementId, item.id);
    let tabDependents = findTabDependents(tabListToRemove);
    let rowListToRemove: Row[] = tabDependents.rowList;
    let sectionListToRemove: Section[] = tabDependents.sectionList;
    let elementListToRemove: Element[] = tabDependents.elementList;
    dispatch(startRemoveByDustbin(rowListToRemove, sectionListToRemove, elementListToRemove, tabListToRemove));
  };

  const renderSubTabList = () => {
    return subTabList.map((item, i) => {
      return (
        <div key={`${item.id}`} className="card border-0">
          <div className="" id="sub-tab">
            <h5 className="mb-0">
              <button
                className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
                data-toggle="collapse"
                data-target={`#SubTab-content-${item.id}`}
                aria-expanded="false"
                aria-controls={`SubTab-content-${item.id}`}
              >
                <div className="row">
                  <div className="col-sm-10">
                    {item.name}
                  </div>
                  <div className="col-sm-2">
                    <i className="fa fa-trash-o" aria-hidden="true" onClick={(e) => {
                      e.stopPropagation();
                      removeTab(item);
                    }}></i>
                  </div>
                </div>
              </button>
            </h5>
          </div>
          <div
            id={`SubTab-content-${item.id}`}
            className="collapse"
            aria-labelledby="sub-tab"
          >
            <div className="card-body theam-card">
              <div className="form-group row">
                <label
                  htmlFor="sub-tab-name"
                  className="col-sm-4 col-form-label font-size-12 align-text-left"
                >
                  Tab Name
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    className="form-control theam-textbox"
                    id="sub-tab-name"
                    value={item.name}
                    onChange={(e) => {
                      editSubTabName(e, item);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div key={`${tab.id}`} className="card border-0">
      <div className="" id="tab">
        <h5 className="mb-0">
          <button
            className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
            data-toggle="collapse"
            data-target={`#Tab-content-${tab.id}`}
            aria-expanded="false"
            aria-controls={`Tab-content-${tab.id}`}
          >
            <div className="row">
              <div className="col-sm-10">{tabCardDisplayName}</div>
              <div className="col-sm-2">
                <i
                  className="fa fa-trash-o"
                  aria-hidden="true"
                  onClick={(e) => {
                    e.stopPropagation();
                    removeTab(tab);
                  }}
                ></i>
              </div>
            </div>
          </button>
        </h5>
      </div>
      <div
        id={`Tab-content-${tab.id}`}
        className="collapse"
        aria-labelledby="tab"
      >
        <div className="card-body theam-card">
          {/* {tab.isDropDownTab && (
            <button
              type="button"
              className="btn btn-danger btn-sm font-size-12"
              onClick={addNewTabOption}
            >
              +
            </button>
          )} */}
          <div className="form-group row">
            <label
              htmlFor="tab-name"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              {tab.isDropDownTab ? "Group Name" : "Tab Name"}
            </label>
            <div className="col-sm-8">
              <input
                type="text"
                className="form-control theam-textbox"
                id="tab-name"
                value={tab.isDropDownTab ? tab.tabGroupTitle : tab.name}
                onChange={(e) => {
                  tab.isDropDownTab ? editTabGroupName(e) : editTabName(e);
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label
              htmlFor="field-disabled"
              className="col-sm-4 col-form-label font-size-12 align-text-left"
            >
              Display
            </label>
            <div className="col-sm-2 mt-1">
              <Switch
                checked={tab.display}
                onChange={() => {
                  const newElement = produce(tab, (draft) => {
                    draft.display = !draft.display;
                  });
                  dispatch(startEditTab(newElement));
                }}
                onColor="#86d3ff"
                onHandleColor="#2693e6"
                handleDiameter={15}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={10}
                width={24}
                className="react-switch"
                id="field-disabled"
              />
            </div>
          </div>
          {tab.isDropDownTab && (
            <Accordion defaultActiveKey="0">
              <Card className="theam-component">
                <Accordion.Toggle
                  as={Button}
                  variant="outline-dark"
                  className="theam-font align-text-left"
                  eventKey={`${tab.id}`}
                >
                  <div className="row">
                    <div className="col-sm-10">Tab Dropdown Options</div>
                    <div className="col-sm-2">
                      <i
                        className="fa fa-plus"
                        onClick={(e) => {
                          e.stopPropagation();
                          addNewTabOption();
                        }}
                      ></i>
                    </div>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={`${tab.id}`}>
                  <Card.Body className="p-0">
                    <div key={`${tab.id}-main`} className="card border-0">
                      <div className="" id="sub-tab-main">
                        <h5 className="mb-0">
                          <button
                            className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
                            data-toggle="collapse"
                            data-target={`#SubTab-content-${tab.id}-main`}
                            aria-expanded="false"
                            aria-controls={`SubTab-content-${tab.id}-main`}
                          >
                            {tab.name}
                          </button>
                        </h5>
                      </div>
                      <div
                        id={`SubTab-content-${tab.id}-main`}
                        className="collapse"
                        aria-labelledby="sub-tab-main"
                      >
                        <div className="card-body theam-card">
                          <div className="form-group row">
                            <label
                              htmlFor="sub-tab-name-main"
                              className="col-sm-4 col-form-label font-size-12 align-text-left"
                            >
                              Tab Name
                            </label>
                            <div className="col-sm-8">
                              <input
                                type="text"
                                className="form-control theam-textbox"
                                id="sub-tab-name-main"
                                value={tab.name}
                                onChange={(e) => {
                                  editTabName(e);
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {tab.isDropDownTab && renderSubTabList()}
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          )}
        </div>
      </div>
    </div>
  );
};

export default TabItemProperties;
